import { render, staticRenderFns } from "./EditRecipeSteps.vue?vue&type=template&id=54df64a2&scoped=true"
import script from "./EditRecipeSteps.vue?vue&type=script&lang=js"
export * from "./EditRecipeSteps.vue?vue&type=script&lang=js"
import style0 from "./EditRecipeSteps.vue?vue&type=style&index=0&id=54df64a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54df64a2",
  null
  
)

export default component.exports